import Image1 from "../../assets/test1.png";
import Image2 from "../../assets/test3.jpg";
import Image3 from "../../assets/test2.jpg";
import Image4 from "../../assets/test4.jpg";

export const Data = [
    {
        id:1,
        image: Image1,
        title:"Bipin Bihari singh",
        description:"A really good job, all aspects of the project were follwed step by step and with good result",
    },
    {
        id:2,
        image: Image2,
        title:"Chhotu kumar",
        description:"They did a great job on my website design and I enjoyed working wiht them! Super happy customer!",
    },
    {
        id:3,
        image: Image3,
        title:"Lav patel",
        description:"So easy and great to work with. organized, efficient, delivers...all around great experience.",
    },
    {
        id:4,
        image: Image4,
        title:"Rahul Bhartiya",
        description:"They understood all the requirements from day one and went above and beyond to make sure project is completed with full satisfaction! ",
    }
]

